/* L'Paige markdown event page (sections/lp-markdown): event state + countdown, the hero shade viewer,
   sticky add-all bar, smooth jumps, and "add all to bag". */
(function () {
  if (window.__lpMarkdown) return;
  window.__lpMarkdown = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Adds several variants in one request, then hands the response to the theme's cart drawer.
  function addAll(button, errorEl, fallback) {
    if (button.getAttribute('aria-disabled') === 'true') return;
    var items;
    try { items = JSON.parse(button.dataset.items || '[]'); } catch (e) { items = []; }
    if (!items.length) return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var spinner = button.querySelector('.loading__spinner');
    var body = { items: items };
    if (cart) {
      body.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      body.sections_url = window.location.pathname;
      cart.setActiveElement(button);
    }

    function fail(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }
    if (errorEl) errorEl.hidden = true;
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          fail(response.description || response.message || fallback);
          return;
        }
        if (!cart) {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'lp-markdown', cartData: response });
        }
        cart.classList.remove('is-empty');
        cart.renderContents(response);
      })
      .catch(function (error) {
        console.error(error);
        fail(fallback);
      })
      .finally(function () {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function initViewer(root) {
    var viewer = root.querySelector('[data-md-viewer]');
    if (!viewer) return;
    var swatches = Array.prototype.slice.call(viewer.querySelectorAll('[data-md-swatch]'));
    var shots = viewer.querySelectorAll('[data-md-shot]');
    var panels = viewer.querySelectorAll('[data-md-panel]');

    function select(index, focus) {
      swatches.forEach(function (swatch) {
        var on = swatch.dataset.mdSwatch === index;
        swatch.classList.toggle('is-active', on);
        swatch.setAttribute('aria-checked', on ? 'true' : 'false');
        swatch.tabIndex = on ? 0 : -1;
        if (on && focus) swatch.focus();
      });
      shots.forEach(function (shot) {
        var on = shot.dataset.mdShot === index;
        if (on) shot.loading = 'eager';
        shot.classList.toggle('is-active', on);
      });
      panels.forEach(function (panel) { panel.hidden = panel.dataset.mdPanel !== index; });
    }

    swatches.forEach(function (swatch, i) {
      swatch.addEventListener('click', function () { select(swatch.dataset.mdSwatch, false); });
      swatch.addEventListener('keydown', function (event) {
        var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[event.key];
        if (!step) return;
        event.preventDefault();
        var next = swatches[(i + step + swatches.length) % swatches.length];
        select(next.dataset.mdSwatch, true);
      });
    });

    // Warm the other shots once the page has settled, so switching shades is instant.
    window.addEventListener('load', function () {
      setTimeout(function () { shots.forEach(function (shot) { shot.loading = 'eager'; }); }, 1500);
    });
  }

  // Lookbook rail: arrows step one portrait at a time; the bar shows how far along you are.
  function initRail(root) {
    root.querySelectorAll('[data-md-rail]').forEach(function (rail) {
      var track = rail.querySelector('[data-md-rail-track]');
      var prev = rail.querySelector('[data-md-rail-prev]');
      var next = rail.querySelector('[data-md-rail-next]');
      var bar = rail.querySelector('[data-md-rail-bar]');
      if (!track || !prev || !next) return;
      function step() {
        var card = track.querySelector('.lp-md-model');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var x = track.scrollLeft;
        prev.disabled = x <= 2;
        next.disabled = x >= max - 2;
        if (!bar) return;
        var visible = max > 0 ? track.clientWidth / track.scrollWidth : 1;
        bar.style.width = Math.max(visible * 100, 8) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (x / max) * (100 / visible - 100) : 0) + '%)';
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function init(root) {
    if (root.__lpMd) return;
    root.__lpMd = true;

    var start = Date.parse(root.dataset.start || '');
    var end = Date.parse(root.dataset.end || '');
    var forced = root.dataset.force || '';
    var whenEls = root.querySelectorAll('[data-when]');
    var countEls = root.querySelectorAll('[data-md-count]');
    var unitEls = root.querySelectorAll('[data-md-unit]');
    var leftEls = root.querySelectorAll('[data-md-left]');
    var leftWraps = root.querySelectorAll('[data-md-left-wrap]');
    var state = null;

    function stateAt(now) {
      if (forced) return forced;
      if (!isNaN(start) && now < start) return 'pre';
      if (!isNaN(end) && now >= end) return 'ended';
      return 'live';
    }

    function setState(next) {
      if (next === state) return;
      state = next;
      root.dataset.state = next;
      whenEls.forEach(function (el) { el.hidden = el.dataset.when.split(' ').indexOf(next) === -1; });
      // links go to the sale copy during the event, the main product otherwise
      root.querySelectorAll('[data-href-live]').forEach(function (a) {
        var url = next === 'live' ? a.dataset.hrefLive : a.dataset.hrefOff;
        if (url) a.setAttribute('href', url);
      });
    }

    // Before the start: count to the start. During: count to the end. After: no countdown.
    function tick() {
      var now = Date.now();
      setState(stateAt(now));
      var target = state === 'pre' ? start : state === 'live' ? end : NaN;
      var left = isNaN(target) ? 0 : Math.floor((target - now) / 1000);
      var show = left > 0;
      countEls.forEach(function (el) { el.hidden = !show; });
      leftWraps.forEach(function (el) { el.hidden = !show; });
      if (!show) return;
      var parts = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
      unitEls.forEach(function (el) { el.textContent = pad(parts[el.dataset.mdUnit]); });
      var short = (parts.d ? parts.d + 'd ' : '') + pad(parts.h) + ':' + pad(parts.m) + ':' + pad(parts.s);
      leftEls.forEach(function (el) { el.textContent = short; });
    }
    tick();
    setInterval(tick, 1000);

    initViewer(root);
    initRail(root);

    // Sticky bar: shown once the hero has scrolled away, hidden again over the footer.
    var bar = root.querySelector('[data-md-bar]');
    var hero = root.querySelector('[data-md-hero]');
    var footer = document.querySelector('.footer, footer');
    if (bar && hero && 'IntersectionObserver' in window) {
      var seen = new Map([[hero, true]]);
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { seen.set(entry.target, entry.isIntersecting); });
        var show = !seen.get(hero) && !seen.get(footer);
        bar.classList.toggle('is-shown', show);
        bar.inert = !show;
      });
      [hero, footer].forEach(function (el) { if (el) io.observe(el); });
    }

    // 'Ask our team' opens the Shopify Inbox chat when it's on the page; otherwise the link goes to the contact page.
    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-md-chat]');
      if (!link) return;
      var chat = document.querySelector('shopify-chat');
      if (!chat || typeof chat.show !== 'function') return;
      event.preventDefault();
      chat.show();
    });

    // Smooth jumps, with a brief outline on a shade card.
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link || !root.contains(link)) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (target.classList.contains('lp-md-card') || target.classList.contains('lp-md-model')) {
        target.classList.add('is-flash');
        setTimeout(function () { target.classList.remove('is-flash'); }, 1800);
      }
    });

    var fallback = root.dataset.error || 'Something went wrong.';
    root.querySelectorAll('[data-md-addall]').forEach(function (button) {
      button.addEventListener('click', function () {
        var errorEl = button.parentElement.querySelector('[data-md-error]') ||
          (button.closest('.lp-md-hero__copy') || root).querySelector('[data-md-error]');
        addAll(button, errorEl, fallback);
      });
    });
  }

  function boot() { document.querySelectorAll('[data-lp-md]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-md]');
    if (root) init(root);
  });
})();
